export interface IHeader {
	header: string;
	name: string;
	width: number;
	align?: 'start' | 'center' | 'end';
}

export const hashtag_header_arr: IHeader[] = [
	{ header: '', name: 'check', width: 44 },
	{ header: '해시태그', name: 'hashtag', width: 200 },
	{
		header: '총 콘텐츠 수\n(전체, 인스타그램)',
		name: 'ig_content_count',
		width: 130,
	},
	{
		header: '경쟁률\n(인스타그램)',
		name: 'ig_competition',
		width: 110,
	},
	{
		header: '최근 콘텐츠 수\n(최근 30일, 유튜브)',
		name: 'yt_content_count',
		width: 130,
	},
	{
		header: '경쟁률\n(유튜브)',
		name: 'yt_competition',
		width: 110,
	},
	{
		header: '성장성',
		name: 'growth',
		width: 110,
	},
	{
		header: '유사 해시태그',
		name: 'similar_hashtag_list',
		width: 200,
	},
];

export const contents_top_header_arr: IHeader[] = [
	{ header: '상위노출된 해시태그', name: 'hashtag', width: 160 },
	{
		header: '콘텐츠',
		name: 'content',
		width: 120,
	},
	{
		header: '인플루언서',
		name: 'profile',
		width: 240,
	},
	{
		header: '팔로워/구독자',
		name: 'follower_count',
		width: 120,
	},
	{
		header: '해시태그 경쟁률',
		name: 'hashtag_competition',
		width: 120,
	},
	{
		header: '유지 기간',
		name: 'retention_period',
		width: 130,
	},
	{
		header: '최고 순위',
		name: 'top_ranking',
		width: 100,
	},
];

export const search_header_arr: IHeader[] = [
	{
		header: '크리에이터 계정',
		name: 'profile',
		width: 275,
	},
	{
		header: '링크',
		name: 'link',
		width: 57,
	},
	{
		header: '카테고리',
		name: 'category',
		width: 219,
		align: 'start',
	},
	{
		header: '팔로워 수',
		name: 'followers',
		width: 120,
	},
	{
		header: '메모',
		name: 'memo',
		width: 250,
	},
	{
		header: '콘텐츠',
		name: 'contents',
		width: 50,
	},
];

export const more_1000_follower_header_arr: IHeader[] = [
	{
		header: '아이디',
		name: 'id',
		width: 260,
	},
	{
		header: '카테고리',
		name: 'category',
		width: 579,
	},
	{
		header: '팔로워',
		name: 'follower',
		width: 121,
	},
];
// 설명: 크리에이터 랭킹 테이블 헤더
export const creator_ranking_header_arr: IHeader[] = [
	{
		header: 'NO.',
		name: 'NO',
		width: 22,
	},
	{
		header: '',
		name: 'rankChange',
		width: 40,
	},
	{
		header: '크리에이터 계정',
		name: 'creator',
		width: 260,
	},
	{
		header: '카테고리',
		name: 'category',
		width: 200,
	},
	{
		header: '오디언스',
		name: 'audience',
		width: 140,
	},
	{
		header: '팔로워 수',
		name: 'follower',
		width: 70,
	},
	{
		header: '30일 성장률 (팔로워 증감)',
		name: 'followerChange',
		width: 170,
	},

	{
		header: '랭킹포인트',
		name: 'rankingPoint',
		width: 120,
	},
];
